// extracted by mini-css-extract-plugin
export default {"checkbox-indicator":"Switch_checkbox-indicator__BCU7E","input":"Switch_input__8UvoB","check-dot":"Switch_check-dot__QtelS"};